import axios from 'axios'

axios.defaults.baseURL = 'https://api.dovetailjewelry.com/'
//axios.defaults.baseURL = '/api'

axios.defaults.headers.post['Content-Type'] = 'application/json'

// Add a request interceptor
axios.interceptors.request.use((config) => {
    // Do something before request is sent
    config.params.lang = localStorage.getItem('lang') || 'cn'
    config.params.v = 'pc'

    return config
}, function (error) {
    // Do something with request error
    return Promise.reject(error)
})

// Add a response interceptor
axios.interceptors.response.use((response) => {
    // Do something with response data
    return response
}, function (error) {
    return Promise.reject(error)
})

export default axios

